import React, {useEffect, useState} from 'react';
import {
    SHOPIFY_BLOG_FIELDS_LIST,
} from "../../constants/shopify.constant";
import _ from "lodash";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {
    syncShopifyBlogsList
} from "../../../common/services/cloud-function-service";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import {searchShopifyBlogs, updateSingleShopifyBlog} from "../../services/shopify-blog-data-service";
import RenderFields from "../../../common/ui/render-fields";
import {PROMPT_INPUT_FIELDS} from "../../../content/constants/prompt.constant";
import {BLOG_INPUT_FIELDS} from "../../constants/shopify-blog.constant";

const ShopifyBlogList = () => {
    const [initialStep, setInitialStep] = useState(true);
    const [blogsList, setBlogsList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(null);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);
    const [editMode, setEditMode] = useState(false);

    useEffect(() => {
        if (initialStep) {
            getShopifyBlogList();
            setInitialStep(false);
        }
    }, [initialStep]);

    const getShopifyBlogList = async () => {
        setDataFetchInProgress(true);

        const searchCriteriaList = [];
        const blogListResult = await searchShopifyBlogs(searchCriteriaList);

        setBlogsList(_.orderBy(blogListResult, ['created_at'], ['desc']));
        setDataFetchInProgress(false);
    }

    const startBlogSyncProcess = async () => {
        setDataFetchInProgress(true);
        await syncShopifyBlogsList();
        await getShopifyBlogList();
        setDataFetchInProgress(false);
    }

    const handleDetailChanges = (event, blogIndex) => {
        const {name, value, type} = event.target;

        // extract blog from blogsList based on blogIndex
        const existingBlogList = [...blogsList];
        const existingBlog = existingBlogList[blogIndex];

        if (type === 'checkbox') {
            existingBlog[name] = !existingBlog[name];
        } else if (type === 'number') {
            existingBlog[name] = _.parseInt(value);
        } else {
            existingBlog[name] = value;
        }

        existingBlogList[blogIndex] = existingBlog;
        setBlogsList(existingBlogList);

        saveBlog(existingBlog);
    }

    const saveBlog = async (existingBlog) => {
        await updateSingleShopifyBlog(existingBlog);
    }

    return (
        <>
            <div className="flex justify-start">
                <div className="w-full mt-2 flex justify-between">

                    <div className="flex items-center text-lg font-bold text-gray-500">
                        Shopify Blogs
                    </div>

                    <div className="mr-4">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>

                    <div className="ml-2 flex items-center justify-center">
                        <button
                            className="button-outline-gray px-4 py-2 flex items-center justify-center mr-2"
                            onClick={() => setEditMode(!editMode)}>
                            {!editMode &&
                                <span>Edit Blogs</span>
                            }

                            {editMode &&
                                <span>Complete Edit Blogs</span>
                            }
                        </button>

                        <button
                            className="button-gray px-4 py-2 flex items-center justify-center"
                            onClick={startBlogSyncProcess}>
                            <span>Sync Shopify Blogs</span>
                        </button>
                    </div>

                </div>
            </div>

            <div className="flex justify-start">

                <div
                    className="shopify-bulk-operation-table-container w-full mt-4  overflow-y-scroll border-y border-gray-400 bg-white">

                    <ShowEmptyListMessage
                        dataList={blogsList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Shopify Blogs'}/>

                    {blogsList?.length > 0 &&
                        <table className="w-full">
                            <thead className="">
                            <tr>
                                <th className="p-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">S.No</th>
                                {SHOPIFY_BLOG_FIELDS_LIST?.map((blogField, rowIndex) => (
                                    <th key={`th-${rowIndex}`}
                                        className="p-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">{blogField?.label}</th>
                                ))}

                                {/*<th className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">Action</th>*/}
                            </tr>
                            </thead>
                            <tbody className="">
                            {blogsList?.map((blog, blogIndex) => (
                                <tr key={`row-${blogIndex}`} className="border border-gray-400">
                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center">
                                            {blogIndex + 1}
                                        </div>
                                    </td>

                                    {SHOPIFY_BLOG_FIELDS_LIST?.map((blogField, columnIndex) => (
                                        <React.Fragment key={`column-${blogIndex}-${columnIndex}`}>
                                            <td className="p-2 border border-gray-400 m-auto text-center">

                                                {blog[blogField?.attribute] && (!editMode || (editMode && blogField?.attribute !== 'type')) &&
                                                    <>{blog[blogField?.attribute]}</>
                                                }

                                                {editMode && blogField?.attribute === 'type' &&
                                                    <RenderFields
                                                        parentForm={blog}
                                                        noFieldLabel={true}
                                                        handleDetailChanges={(event) => {
                                                            handleDetailChanges(event, blogIndex);
                                                        }}
                                                        fieldList={_.groupBy(BLOG_INPUT_FIELDS, 'group')['filter']}
                                                        enableEdit={true}
                                                        fieldClassName={'w-full'}/>
                                                }

                                            </td>
                                        </React.Fragment>
                                    ))}

                                    {/*<td className="w-64 p-2 border border-gray-400 m-auto">

                                    </td>*/}
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    }
                </div>

            </div>

        </>
    )
}

export default ShopifyBlogList
